/* Polsk katalog for locale-autopilot-followup.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'ap.skip.title': 'Pomiń działanie następcze',
  'ap.skip.nextMonth': 'Przypomnij mi w przyszłym miesiącu',
  'ap.skip.always': 'Ignoruj ten punkt',
  'ap.skip.help': 'Odłóż punkt na przyszły miesiąc albo zignoruj właśnie ten punkt. Nowe faktury, klienci i inne nowe ustalenia nadal będą się pojawiać.',
  'ap.skip.itemFallback': 'Ten punkt do wyjaśnienia',
  'ap.skip.all': 'Pomiń wszystkie',
  'ap.skip.allInvoices': 'Wszystkie dokumenty z tej listy',
  'ap.skip.allCustomers': 'Wszyscy klienci z tej listy',
  'ap.agent.followup.title': 'Agent działań następczych',
  'ap.agent.followup.detail': 'Wychwytuje informacje i rozbieżności, które nie należą do żadnego agenta składania deklaracji.',
  'ap.permission.followup.label': 'Agent działań następczych',
  'ap.permission.followup.desc': 'Wychwytuje informacje, rozmowy z klientami i rozbieżności, które nie należą do żadnego agenta składania deklaracji.',
  'ap.lineIgnoredToast': 'Ten punkt jest ignorowany. Nowe punkty do wyjaśnienia nadal będą się pojawiać.',
  'ap.linesSkippedToast': 'Pominięte punkty: {{count}}.',
  'ap.followup.correctionOne': 'Błędy do poprawienia: {{count}}.',
  'ap.followup.correctionMany': 'Błędy do poprawienia: {{count}}.',
  'ap.followup.correctionDetailOne': 'Punkty do poprawienia: {{count}}',
  'ap.followup.correctionDetailMany': 'Punkty do poprawienia: {{count}}',
  'ap.followup.mustCorrect': 'Wymaga poprawy',
  'ap.followup.correct': 'Popraw',
  'ap.followup.correctInSettings': 'Popraw w ustawieniach',
});
